import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { envConfig} from "../config";

const config = envConfig();

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: `${config.REACT_APP_APP_INSIGHTS_KEY}`,
    enableAutoRouteTracking: true,
    disableTelemetry: false,
    loggingLevelConsole: 2,
  },
});

appInsights.loadAppInsights();

export { appInsights };
